import { useTickets } from 'contexts/TicketsContext';
import { GetTicketsResponseDTO } from 'declarations/dto/tickets';
import { NoopT } from 'declarations/types/common';
import usePushNotifications from 'hooks/common/usePushNotifications';

export interface TicketsPageHookProps {
  ticketsPages: GetTicketsResponseDTO[] | undefined | null;
}

type UseTicketsPageT = {
  hasNextTicketsPage: boolean | undefined;
  handleSelectTicket: (ticketId: string) => NoopT;
};

const useTicketsPage = (
  { ticketsPages }: TicketsPageHookProps = { ticketsPages: null }
): UseTicketsPageT => {
  /**
   * Hooks
   */
  const { setTicketId, hasNextTicketsPage } = useTickets();
  usePushNotifications();

  /**
   * Handlers
   */
  const handleSelectTicket = (ticketId: string) => () => {
    setTicketId(ticketId);
  };

  return {
    handleSelectTicket,
    hasNextTicketsPage,
  };
};

export default useTicketsPage;
